import { useContext, useEffect, createRef, useState } from 'react';

import styles from './FilesDetailsConferenceDetailsComponent.module.css';

import { GlobalContext } from "../../../contexts/globalContext";
import { AddConferenceContext } from "../../../contexts/addConferenceContext";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import DetailsCardComponent from './DetailsCardComponent';
import DarkButtonComponent from '../../commons/DarkButtonComponent';
import PreviewPdfFileComponent from '../../conferenceScreen/filesComponents/PreviewPdfFileComponent';
import PreviewImageFileComponent from '../../conferenceScreen/filesComponents/PreviewImageFileComponent';
import PreviewVideoFileComponent from '../../conferenceScreen/filesComponents/PreviewVideoFileComponent';

import imgAdd from '../../../graphics/Popups/Icon Files Add.png';

const FilesDetailsConferenceDetailsComponent = () => {
    const { socketRef, appWidth, appHeight, currentConference, setAlertMessage } = useContext(GlobalContext);
    const { setDeleteClicked, fileList, setFileList, openFiles, setConferenceAddFiles } = useContext(AddConferenceContext);

    const [topicFilesOpened, setTopicFilesOpened] = useState([])


    const oxDivider = window.innerWidth / appWidth;
    const oyDivider = window.innerHeight / appHeight;

    const icon = (type) => {
        switch (true) {
            case type.includes("image"): return "file-image";
            case type.includes("video"): return "file-video";
            case type.includes("pdf"): return "file-pdf";
            case type.includes("word"): return "file-word";
            case type.includes("excel"): return "file-excel";
            case type.includes("site"): return "file-export";
            default: return "file-lines";
        }
    };

    useEffect(() => {
        let type = openFiles.moderator ? "Topic" : "Subtopic";
        socketRef.current.emit("CONFERENCE_GET_TOPIC_ATTACHED_DOCUMENTS", { parentId: openFiles._id, type }, callback => {
            if (!callback.error) setFileList(callback.response);
        });


        const refreshHandler = (_, parentId) => {

            if (parentId === openFiles?._id) {

                socketRef.current.emit("CONFERENCE_GET_TOPIC_ATTACHED_DOCUMENTS", { parentId: openFiles._id, type }, callback => {
                    if (!callback.error) setFileList(callback.response);
                });
            }
        };

        socketRef.current.on('REFRESH_CONFERENCE_TOPICS', refreshHandler);

        return () => {
            socketRef.current.off('REFRESH_CONFERENCE_TOPICS', refreshHandler);
        };
    }, [openFiles]);


    const reloadFiles = () => {
        let type = openFiles.moderator ? "Topic" : "Subtopic";
        socketRef.current.emit("CONFERENCE_GET_TOPIC_ATTACHED_DOCUMENTS", { parentId: openFiles._id, type }, callback => {
            if (!callback.error) setFileList(callback.response);
        });
    };

    const handleDeleteFile = (fileId) => {
        socketRef.current.emit("CONFERENCE_DELETE_DOCUMENT", {
            parentId: openFiles._id,
            refType: openFiles.moderator ? "Topic" : "Subtopic",
            conferenceFileId: fileId,
            conferenceId: currentConference
        }, () => {
            setDeleteClicked(false);
            reloadFiles();
        });
    };

    const handleDelete = (file) => {
        if (!file.ref.current) return;

        const rect = file.ref.current.getBoundingClientRect();

        let x = rect.x
        let y = rect.y

        if (x / oxDivider - 1024 + 739 > appWidth) {
            x = (appWidth - 760) * oxDivider
        }

        if (y / oyDivider + 255 > appHeight) {
            y = (appHeight - 275) * oyDivider
        }

        setDeleteClicked({
            shown: true,
            funct: () => handleDeleteFile(file._id),
            name: "File",
            x: x,
            y: y,
            onClose: () => setDeleteClicked(),
        });
    };

    const onClickFile = (file) => {
        if (file.docsFile.type === "site") {
            setAlertMessage({ type: "WARNING", message: "Preview not available for site files." });
            return;
        }

        if (topicFilesOpened.find(f => f.uid === file._id)) {
            setTopicFilesOpened(files => files.filter(a => a.uid !== file._id));
        } else {
            setTopicFilesOpened(files => [...files, {
                uid: file._id, x: 0, y: appHeight / 2, type: file.docsFile.type, path: file.docsFile.path, scale: 1, rotation: 0
            }])
        }
    }

    const getFileComponent = (file) => {
        switch (file.type) {
            case "pdf":
                return <PreviewPdfFileComponent key={file.uid} file={file} setTopicFilesOpened={setTopicFilesOpened} />
            case "image":
                return <PreviewImageFileComponent key={file.uid} file={file} setTopicFilesOpened={setTopicFilesOpened} />
            case "video":
                return <PreviewVideoFileComponent key={file.uid} file={file} setTopicFilesOpened={setTopicFilesOpened} />
            default:
                return "";
        }

    }

    return (
        <>
            <DarkButtonComponent style={{ width: '98%', position: 'absolute', top: 88, marginBottom: 40, zIndex: 10 }} onClick={() => setConferenceAddFiles(true)}>
                <FontAwesomeIcon className={styles.iconPlus} icon={byPrefixAndName.fas['plus']} /> Add files
            </DarkButtonComponent>
            <DetailsCardComponent title="Files" height={appHeight - 83} isList={fileList.length === 0 ? false : true} isBlank={fileList.length === 0 ? true : false}>
                <div style={{ width: "100%", height: "100%" }}>
                    <div className={styles.openFiles} style={{ justifyContent: fileList.length === 0 ? "center" : "" }}>
                        <div className={styles.noFiles} style={{ justifyContent: fileList.length === 0 ? "center" : "", alignItems: fileList.length === 0 ? "center" : "" }}>
                            {fileList.length === 0 ? (
                                <>
                                    <img src={imgAdd} alt="icon add" className={styles.imgAdd} onClick={() => setConferenceAddFiles(true)} />
                                    <div className={styles.description}>Add files to topic</div>
                                    <div style={{ textAlign: "center", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>{openFiles.name}</div>
                                </>
                            ) : (
                                fileList.map((file, index) => {
                                    file.ref = createRef();
                                    return <div key={index} className={styles.fileCard}>
                                        <FontAwesomeIcon
                                            ref={file.ref}
                                            className={styles.iconButton}
                                            style={{ right: 10 }}
                                            icon={byPrefixAndName.fal["trash"]}
                                            onClick={(e) => { handleDelete(file) }}
                                        />
                                        <FontAwesomeIcon className={styles.icon} icon={byPrefixAndName.fas[icon(file.docsFile.type)]} />
                                        <div className={styles.fileDetails} onClick={() => onClickFile(file)}>
                                            {file.docsFile.name}
                                            <div className={styles.fileDescription}>
                                                Added by:
                                                <div className={styles.fileAddedBy}>{file.addedBy?.name}</div>
                                            </div>
                                        </div>
                                    </div>
                                })
                            )}
                        </div>
                    </div>
                </div>
            </DetailsCardComponent>
            {topicFilesOpened.map((file) => (
                getFileComponent(file)
            ))}
        </>
    );
};

export default FilesDetailsConferenceDetailsComponent;
